import React, {Component} from 'react';
import { responsiveFontSize, responsiveHeight, responsiveWidth } from '../Services/Utilities';
import {Col, Row } from 'reactstrap';
import LatexViewComponent2 from './LatexViewComponent2';
import MathJax from 'react-mathjax2'
import LatexViewComponent3 from './LatexViewComponent3';
import LatexViewComponent from './LatexViewComponent';

const NUMERIC_KEY = +1
const VARIABLE_KEY = +2

class KeyboardComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
            Keyboard:{
                NumericKeys:[],
                VariableKeys:[]
            }
        }

        this.KeysBlock = this.KeysBlock.bind(this)
        this.SingleKey = this.SingleKey.bind(this)

        this.EnterKeyToLine = this.EnterKeyToLine.bind(this)
        this.EnterVarKeyToLine = this.EnterVarKeyToLine.bind(this)
        this.AddDot = this.AddDot.bind(this)
        this.AddPlus = this.AddPlus.bind(this)
        this.AddMinus = this.AddMinus.bind(this)
        this.AddDot2 = this.AddDot2.bind(this)
        this.AddDevide = this.AddDevide.bind(this)
        this.AddEqual = this.AddEqual.bind(this)
        this.AddBracket_right = this.AddBracket_right.bind(this)
        this.AddBracket_left = this.AddBracket_left.bind(this)
        this.RemoveOperand = this.RemoveOperand.bind(this)
    }

    render(){
        return(
            <div style = {{
                marginTop:responsiveHeight(1),
                borderTop:1, 
                borderLeft:1, 
                borderRight:3, 
                borderBottom:3, 
                borderStyle:'solid',
                borderColor:"#cccccc",
                borderRadius: responsiveFontSize(0.25)
            }}

            onMouseEnter = {() => {
                this.props.Father.setState({
                    KeyboardIn: true
                })
            }}

            onMouseLeave = {() => {
                 this.props.Father.setState({
                     KeyboardIn: false
                 })
             }}>
                {this.KeysBlock()}
            </div>
        )
    }

    KeysBlock(){
        let father = this.props.Father

        return(
            <div>

                {/* Normal keys */}
                <Row style = {{width:'95%', marginLeft:'2%', marginTop: responsiveHeight(1)}}>
                    {[...this.props.keyboard.NumericKeys.map((k) => ({...k, Type:NUMERIC_KEY})),
                    ...this.props.keyboard.VariableKeys.map((k) => ({...k, Type:VARIABLE_KEY}))]
                    .sort((a, b) => (a.Order >= b.Order) ? 1 : -1)

                    .map((k, i) =>this.SingleKey(k,i, this.EnterKeyToLine))}
                </Row>

                {/* Variable keys */}
                {father.state.ShowVarModal ? 
                <Row style = {{width:'95%', marginLeft:'2%'}}>
                    {(father.state.SelectedVariableKey.VImages)
                    .map((n,i) =>this.SingleKey(n,i,this.EnterVarKeyToLine, true, '#f2ffcc'))}
                </Row>: <div/>}

                {/* Operands */}
                <Row style = {{width:'40%', marginLeft:'2%', marginTop: responsiveHeight(0.75)}}>
                    {/* Plus operand */}
                    {this.SingleKey(({
                            TextPresentation:'+'
                        }),0, this.AddPlus, true, '#e6faff')}

                    {/* Minus operand */}
                    {this.SingleKey(({
                            TextPresentation:'-'
                        }),1, this.AddMinus, true, '#e6faff')}

                    {/* Dot operand */}
                    {this.SingleKey(({
                            TextPresentation:'*'
                        }),2, this.AddDot2, true, '#e6faff')}

                    {/* Devide operand */}
                    {this.props.disable_devision ? 
                    <div/> :
                    this.SingleKey(({
                            TextPresentation:'/'
                        }),3, this.AddDevide, true, '#e6faff')}

                    {/* Equal operand */}
                    {!this.props.energy_balance ? 
                    <div/> :
                    this.SingleKey(({
                            TextPresentation:'='
                        }),4, this.AddEqual, true, '#e6faff')}

                    {/* Bracket ( operand */}
                    {this.SingleKey(({
                            TextPresentation:'('
                        }),5, this.AddBracket_right, true, '#e6faff')}

                    {/* Bracket ( operand */}
                    {this.SingleKey(({
                            TextPresentation:')'
                        }),6, this.AddBracket_left, true, '#e6faff')}   

                    {/* Delete operand */}
                        {this.SingleKey(({
                            TextPresentation:'⇐'
                        }),7, this.RemoveOperand, true, '#ffe6e6', true)}      
                </Row>
                <div style = {{height: responsiveHeight(0.1), borderBottom:1, borderColor:'#e6e6e6', borderBottomStyle:'solid'
                ,marginBottom: responsiveHeight(0.5), marginTop: responsiveHeight(1)}}/>

            </div>

                
        )
    }

    SingleKey(k, i, action, variable_operand_key = false, background_color = '#e6e6e6', non_latex = false){
        let father = this.props.father
        
        let latex_formula = `\\large{${variable_operand_key ? k.TextPresentation : (k.NumericKey || k.VariableKey).TextPresentation}}`
        
        let opacity = '100%'

        let key_not_allowed = false
        return(
                    <Col
                        style = {{
                            opacity: opacity,
                            marginLeft: responsiveWidth(0.25), marginTop:responsiveWidth(0.25),
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:background_color, borderRadius: responsiveFontSize(0.25)
                        }}
                        className = "border border-secondary"
                        key = {i}
                        onClick = {() => {
                            action(k)
                        }}
                        >
                    
                            {!non_latex ?
                             <LatexViewComponent3 
                            latex_formula = {latex_formula}
                            /> : <LatexViewComponent 
                                    height = {50}
                                    text = {latex_formula}
                                    NoBorder
                                />}
                        </Col>
        )
    }

    EnterKeyToLine(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(k.Type == VARIABLE_KEY){

            father.setState({
                ShowVarModal: father.state.SelectedVariableKey.Id == k.VariableKey.Id ? !father.state.ShowVarModal : true,

                SelectedVariableKey: k.VariableKey
            })

            return
        }
        
        //Check last key status
        let Last = answer.List.slice(-1)[0]

        //AddDot If last key and new keys are not operands 
        if(Last && Last.IsKey && !(Last.IsInteger && k.NumericKey.IsInteger)){
            answer = this.AddDot(answer)

            father.setState({
                Answer:answer,
            })
        }

        answer.List.push({
            code:k.NumericKey.TextPresentation,
            char: k.NumericKey.IsInteger ? k.NumericKey.TextPresentation : k.KeySimpleForm,

            IsKey: true,
            IsInteger: k.NumericKey.IsInteger,

            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket: answer.LeftBracket,
        })

        answer.Right = true
        answer.Left = false
        answer.RightBracket = false
        answer.LeftBracket = true

        father.setState({
            Answer:answer
        })
    }

    EnterVarKeyToLine(n){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father
        let keyboard = this.props.keyboard
        
        //Check last key status
        let Last = answer.List.slice(-1)[0]

        //AddDot If last key and new keys are not operands 
        if(Last && Last.IsKey){
            answer = this.AddDot(answer)

            father.setState({
                Answer:answer,
            })
        }

        answer.List.push({
            code: keyboard.VariableKeyImages.filter((im) => im.ImageId == n.Id)[0].Image.TextPresentation,
            char: keyboard.VariableKeyImages.filter((im) => im.ImageId == n.Id)[0].ReplacementCharacter,

            IsKey: true,
            IsInteger: false,

            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket: answer.LeftBracket,
        })

        answer.Right = true
        answer.Left = false
        answer.RightBracket = false
        answer.LeftBracket = true

        father.setState({
            ShowVarModal:false,
            Answer:answer
        })

    }

    AddDot(answer){
        let _answer = ({...answer})

        _answer.List.push({
            code:'*',
            char:'*',
            Left: _answer.Left,
            Right: _answer.Right,
            RightBracket: _answer.RightBracket,
            LeftBracket: _answer.LeftBracket,
        })

        _answer.Left = true
        _answer.Right = false
        _answer.RightBracket = true
        _answer.LeftBracket = false
        _answer.IsInteger = false

        return _answer
    
    }

    AddDot2(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(answer.Left)
        {
            return 
        }

        if(!answer.List.length){
            return
        }

        answer.List.push({            
            code:'*',
            char:'*',

            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket: answer.LeftBracket,
        })

        answer.Left = true
        answer.Right = false
        answer.RightBracket = true
        answer.LeftBracket = false
        answer.IsInteger = false

        father.setState({
            Answer:answer,
           
        })
    
    }

    AddPlus(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father 
        if(answer.Left)
        {
            return 
        }
        if(!answer.List.length){
            return
        }

        answer.List.push({
            code:'+',
            char:'+',
            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket: answer.LeftBracket,
        })

        answer.Right = false
        answer.Left = true
        answer.RightBracket = true
        answer.LeftBracket = false
        answer.IsInteger = false

        console.log(answer)

        father.setState({
            Answer:answer,
        })                                                                                     
    }

    AddMinus(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(answer.Left)
        {
            if(answer.List.length && answer.List.slice(-1)[0].char != '=' && answer.List.slice(-1)[0].char == '-')
            {
                return
            } 
        }

        answer.List.push({
            code:'-',
            char:'-',

            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket: answer.LeftBracket,
        })

        answer.Left = true
        answer.Right = false
        answer.RightBracket = true
        answer.LeftBracket = false
        answer.IsInteger = false

        father.setState({
            Answer:answer
        })                                        
    }

    AddDevide(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(answer.Left)
        {
            return 
        }
        if(!answer.List.length){
            return
        }

        answer.List.push({
            code:'/',
            char:'/',

            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket: answer.LeftBracket,
        })

        answer.Left = true
        answer.Right = false
        answer.RightBracket = true
        answer.LeftBracket = false
        answer.IsInteger = false

        father.setState({
            Answer:answer
        })                                                              
    }

    AddEqual(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(answer.Left || !answer.List.length){
            return
        }

        answer.List.push({
            IsLatex:false,
            code:'=',
            char:'=',
            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket:answer.LeftBracket,
        })

       
        answer.Left = true
        answer.Right = false
        answer.IsInteger = false

        father.setState({
            Answer:answer
        })
                       
    }

    AddBracket_right(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(!answer.RightBracket && answer.List.length && answer.List.slice(-1)[0].code != '(')
        {
            return 
        }

        answer.List.push({
            code:'(',
            char:'(',

            Left: answer.Left,
            Right: answer.Right,
            RightBracket:  answer.RightBracket,
            LeftBracket:  answer.LeftBracket,
        })

        answer.echoNumber =
        answer.echoNumber + 1
        
        answer.Left = true
        answer.Right = false
        answer.IsInteger = false

        father.setState({
            Answer:answer
        })                                        
                       
    }

    AddBracket_left(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(!answer.LeftBracket  && answer.List.length)
        {
            return 
        }

        if(answer.echoNumber == 0)
        {
            return
        }                            

        answer.List.push({
            code:')',
            char:')',

            Left: answer.Left,
            Right: answer.Right,
            RightBracket: answer.RightBracket,
            LeftBracket:answer.LeftBracket,                            
        })

        answer.echoNumber =
        answer.echoNumber - 1
        
        answer.Left = false
        answer.Right = true
        answer.IsInteger = false

        father.setState({
            Answer:answer
        })                                        
                       
    }

    RemoveOperand(k){
        let answer = ({...this.props.answer_line})
        let father = this.props.Father

        if(!answer.List.length)
        {
            return
        }

        let Last = answer.List.slice(-1)[0]

        answer.Left = Last.Left
        answer.LeftBracket = Last.LeftBracket
        answer.Right = Last.Right
        answer.RightBracket = Last.RightBracket
        answer.IsInteger = Last.IsInteger

        let echoNumber = answer.echoNumber

        if(Last.char == ')'){
            echoNumber = echoNumber + 1
        }

        if(Last.char == '('){
            echoNumber = echoNumber - 1
        }

        answer.echoNumber = echoNumber

        answer.List.pop()

        father.setState({
            Answer:answer
        }) 
                                                                      
                       
    }


}

export default KeyboardComponent